let initialState = null;

function company(state = initialState, action) {
  if (action.type === "GET_ALL_SUPPLIER") {
    return action.res;
  } else if (action.type === "RESET_PARTNERS") {
    return action.res;
  }else if (action.type === "UPDATE_PARTNERS") {
    return action.res;
  } else {
    return state;
  }
}

export default company;
